export default {
  data () {
    return {
      triggered: false
    }
  },
  methods: {
    triggerHack () {
      this.triggered = !this.triggered
    }
  },
  mounted () {
    setTimeout(this.triggerHack, 50)
  }
}



// WEBPACK FOOTER //
// ./src/modules/helpers/IEHackMixin.js